import React from 'react';
import Form from '../../../CommonComponents/Form';
import { Input } from '../../../CommonComponents/OPL/Input/Input';
import { InputNumberMask } from '../../../CommonComponents/OPL/Input/InputNumberMask';
import withForm from './withForm';

const MiscAssetForm = ({ account, onUpdate, isEditable }) => (
  <Form>
    <Form.Control>
      <InputNumberMask
        label="Value"
        leftIcon="fa fa-dollar-sign"
        allowNegative={false}
        disabled={!isEditable}
        value={account.MarketValue}
        onChange={({ target: { value } }) => onUpdate({ MarketValue: value })}
      />
    </Form.Control>
    <Form.Control>
      <Input
        label="Description"
        disabled={!isEditable}
        value={account.Name}
        onChange={({ target: { value } }) => onUpdate({ Name: value })}
      />
    </Form.Control>
  </Form>
);

export default withForm(MiscAssetForm);
